<template>
  <v-content>
    <v-container>
      <v-tabs
          v-model="tab"
          background-color="transparent"
          grow
      >
        <v-tab
            key="DataMeeting"
        >
          ข้อมูลจัดประชุม
        </v-tab>
        <v-tab
            key="CordiDataMeeting"
        >
          ข้อมูลเงื่อนไขผู้เข้าร่วมประชุม
        </v-tab>
        <v-tab
            key="DataJoinMeeting"
        >
          ข้อมูลผู้เข้าร่วมประชุม
          <v-chip
              class="ml-2"
              color="green"
              dark>
            <span v-if="Cordi_Count == '0'">
              {{ this.JoinMeet.length }} / ไม่จำกัด
            </span>
            <span v-else>
              {{ this.JoinMeet.length }} / {{ Count }}
            </span>
          </v-chip>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item
            key="DataMeeting"
        >
          <v-card>
            <v-card-title>
          <span class="font-weight-bold">
            เพิ่มข้อมูลการจัดประชุม
          </span>
            </v-card-title>
            <v-card-text>
              <v-list>
                <v-list-item>
                  <v-row class="d-flex justify-center">
                    <v-col
                        cols="12"
                        md="8"
                    >
                      <v-text-field
                          label="หัวข้อการจัดประชุม"
                          outlined
                          v-model="Topic"
                          :error="Topic == ''"
                          :error-messages="Topic == '' ? 'หัวข้อการประชุม (ห้ามว่าง)' : ''"
                          persistent-hint
                          required

                      ></v-text-field>
                    </v-col>
                    <v-col
                        cols="12"
                        md="4"
                    >
                      <v-radio-group row v-model="Cordi_Count" @change="ChooseCordiCount">
                        <v-radio label="ไม่จำกัดผู้เข้าร่วม" value="0"></v-radio>
                        <v-radio label="จำกัดผู้เข้าร่วม" value="1"></v-radio>
                      </v-radio-group>
                    </v-col>
                  </v-row>
                </v-list-item>
                <v-list-item v-if="Cordi_Count == '1'">
                  <v-row class="d-flex justify-center">
                    <v-col
                        cols="12"
                        md="4">
                      <v-text-field
                          label="จำนวนผู้เข้าร่วม"
                          type="number"
                          outlined
                          v-model="Count"
                          :error="Count == ''"
                          :error-messages="Count == '' ? 'จำนวนผู้เข้าร่วม (ห้ามว่าง)' : ''"
                          persistent-hint
                          required

                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-list-item>
                <v-list-item>
                  <v-row class="d-flex justify-center">
                    <v-col
                        cols="12"
                        md="6"
                    >
                      <div align="center">
                        <p class="font-weight-bold">
                          วันที่เริ่มต้นจัดงาน
                        </p>
                        <v-date-picker
                            class="ma-10"
                            v-model="Date_start"
                            :landscape="false"
                            locale="th"
                            :color="Date_start == '' ? 'red' : 'primary'"
                        ></v-date-picker>
                      </div>
                    </v-col>
                    <v-col
                        cols="12"
                        md="6">
                      <div align="center">
                        <p class="font-weight-bold">
                          วันที่สิ้นสุดจัดงาน
                        </p>
                        <v-date-picker
                            class="ma-10"
                            v-model="Date_end"
                            :landscape="false"
                            locale="th"
                            :color="Date_end == '' ? 'red' : 'primary'"
                        ></v-date-picker>
                      </div>
                    </v-col>
                  </v-row>
                </v-list-item>
                <v-list-item>
                  <v-row>
                    <v-col
                        cols="12"
                        md="6">
                      <v-text-field
                          type="time"
                          label="เวลาเริ่มต้น"
                          outlined
                          v-model="Time_start"
                          :error="Time_start == ''"
                          :error-messages="Time_start == '' ? 'เวลาเริ่มต้น (ห้ามว่าง)' : ''"
                          persistent-hint
                          required

                      ></v-text-field>
                    </v-col>
                    <v-col
                        cols="12"
                        md="6">
                      <v-text-field
                          type="time"
                          label="เวลาสิ้นสุด"
                          outlined
                          v-model="Time_end"
                          :error="Time_end == ''"
                          :error-messages="Time_end == '' ? 'เวลาสิ้นสุด (ห้ามว่าง)' : ''"
                          persistent-hint
                          required

                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-list-item>
                <v-list-item>
                  <v-row>
                    <v-col
                        cols="12"
                        md="6">
                      <v-autocomplete
                          v-model="DepSelect"
                          label="จัดโดย (หน่วยงาน)"
                          :items="DepartDump"
                          item-text="dep_name"
                          item-value="dep_id"
                          outlined
                          :error="DepSelect == ''"
                          :error-messages="DepSelect == '' ? 'หน่วยงาน (ห้ามว่าง)' : ''"
                          persistent-hint
                          required

                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col
                        cols="12"
                        md="6">
                      <v-text-field
                          label="สถานที่จัด"
                          outlined
                          v-model="Place"
                          :error="Place == ''"
                          :error-messages="Place == '' ? 'สถานที่จัด (ห้ามว่าง)' : ''"
                          persistent-hint
                          required

                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-list-item>
                <v-list-item>
                  <v-textarea v-model="Rm" label="รายล่ะเอียด (ถ้ามี)" outlined></v-textarea>
                </v-list-item>
                <v-list-item>
                  <v-file-input
                      v-model="files"
                      color="deep-purple accent-4"
                      counter
                      label="แนบไฟล์เอกสารประกอบการประชุม"
                      multiple
                      placeholder="เลือกไฟล์"
                      prepend-icon="mdi-paperclip"
                      outlined
                      :show-size="1000"
                      @change="FileSelect"
                  >
                    <template v-slot:selection="{ index, text }">
                      <v-chip
                          v-if="index < 5"
                          color="deep-purple accent-4"
                          dark
                          label
                          small
                      >
                        {{ text }}
                      </v-chip>

                      <span
                          v-else-if="index === 5"
                          class="overline grey--text text--darken-3 mx-2"
                      >
                                +{{ files.length - 2 }} File(s)
                              </span>
                    </template>
                  </v-file-input>
                </v-list-item>
                <v-list-item>
                  <v-alert
                      v-if="alert"
                      prominent
                      type="error"
                  >
                    <v-row align="center" v-for="item in txtAlert" :key="item.id">
                      <v-col class="d-flex grow">- {{ item.Detail }}</v-col>
                    </v-row>
                  </v-alert>
                </v-list-item>
                <v-list-item v-if="FileMeeting.length > 0">
                  <template>
                    <v-row>
                      <v-col cols="12" sm="6" offset-sm="3">
                        <v-card>
                          <v-card-title>
                            ไฟล์ภาพประกอบ
                          </v-card-title>
                          <v-container fluid>
                            <v-row>
                              <v-col
                                  v-for="(file_i, index) in FileMeeting"
                                  :key="index"
                                  class="d-flex child-flex"
                                  cols="12"
                                  md="4"
                              >
                                <v-card flat tile class="d-flex">
                                  <v-img
                                      v-if="file_i.type == 'image'"
                                      :src="file_i.src"
                                      :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                      aspect-ratio="1"
                                      class="grey lighten-2"
                                  >
                                    <template v-slot:placeholder>
                                      <v-row
                                          class="fill-height ma-0"
                                          align="center"
                                          justify="center"
                                      >
                                        <v-progress-circular
                                            indeterminate
                                            color="grey lighten-5"></v-progress-circular>
                                      </v-row>
                                    </template>
                                  </v-img>
                                  <v-img
                                      v-if="file_i.type == 'pdf'"
                                      src="../../assets/Image/pdf.png"
                                      :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                      aspect-ratio="1"
                                      class="grey lighten-2"
                                  >
                                    <template v-slot:placeholder>
                                      <v-row
                                          class="fill-height ma-0"
                                          align="center"
                                          justify="center"
                                      >
                                        <v-progress-circular
                                            indeterminate
                                            color="grey lighten-5"></v-progress-circular>
                                      </v-row>
                                    </template>
                                  </v-img>
                                  <v-card-actions>
                                    <v-btn text
                                           @click="ShowData(file_i.src)">
                                                                                        <span style="color: indigo">
                                                                                            เรียกดู
                                                                                        </span>
                                    </v-btn>
                                  </v-card-actions>
                                </v-card>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card>
                      </v-col>
                    </v-row>
                  </template>
                </v-list-item>
                <v-list-item class="justify-center">
                  <v-radio-group row v-model="Register_Cordi2">
                    <v-radio label="จำกัดการลงทะเบียนตามรายชื่อที่สมัครเข้าร่วมงาน" value="0" color="red"></v-radio>
                    <v-radio label="ไม่จำกัดการลงทะเบียนเข้าร่วมงาน" value="1" color="green"></v-radio>
                  </v-radio-group>
                </v-list-item>
                <v-list-item class="justify-center">
                  <v-radio-group row v-model="Register_Cordi">
                    <v-radio label="ปิดลงทะเบียน" value="0" color="red"></v-radio>
                    <v-radio label="เปิดลงทะเบียน" value="1" color="green"></v-radio>
                  </v-radio-group>
                </v-list-item>
                <v-list-item v-if="Register_Cordi == '1'">
                  <v-row class="d-flex justify-center">
                    <v-col
                        cols="12"
                        md="6"
                    >
                      <div align="center">
                        <v-text-field
                            v-model="Date_reg_start"
                            type="date"
                            label="วันที่เปิดลงทะเบียน"
                            outlined
                            :error="Date_reg_start == ''"
                            :error-messages="Date_reg_start == '' ? 'วันที่เปิดลงทะเบียน (ห้ามว่าง)' : ''"
                            persistent-hint
                            required
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col
                        cols="12"
                        md="6">
                      <div align="center">
                        <v-text-field
                            v-model="Date_reg_end"
                            type="date"
                            label="วันที่สิ้นสุดลงทะเบียน"
                            outlined
                            :error="Date_reg_end == ''"
                            :error-messages="Date_reg_end == '' ? 'วันที่สิ้นสุดลงทะเบียน (ห้ามว่าง)' : ''"
                            persistent-hint
                            required
                        ></v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                </v-list-item>
                <v-list-item>
                  <v-text-field label="รหัสอ้างอิงการประชุม" outlined v-model="LinkGen" readonly></v-text-field>
                </v-list-item>
                <v-list-item>
                  <v-row class="d-flex justify-center">
                    <v-col
                        cols="12"
                        md="10">
                      <v-text-field label="ลิงค์เว็บไซต์รับสมัคร" outlined v-model="url" readonly></v-text-field>
                    </v-col>
                    <v-col
                        cols="12"
                        md="2">
                      <CopyToClipboard :text="url">
                        <v-btn
                            outlined
                            color="puple"
                            @click="Copy"
                        >
                          คัดลอกลิงค์
                        </v-btn>
                      </CopyToClipboard>
                    </v-col>
                  </v-row>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item key="CordiDataMeeting">
          <v-list>
            <v-list-item>
              <v-card style="width: 100%">
                <v-card-title>
          <span class="font-weight-bold">
            ข้อมูลเงื่อนไขผู้เข้าร่วมประชุม
          </span>
                </v-card-title>
                <v-card-text>
                  <v-list>
                    <v-list-item class="justify-center">
                      <v-radio-group row v-model="ChkCordiMeeting">
                        <v-radio label="ไม่กำหนดเงื่อนไข" value="0" color="purple"></v-radio>
                        <v-radio label="กำหนดเงื่อนไข" value="1" color="green"></v-radio>
                      </v-radio-group>
                    </v-list-item>
                  </v-list>
                </v-card-text>
                <v-card-text v-if="ChkCordiMeeting == '1'">
                  <v-row class="justify-center">
                    <v-col
                        cols="12"
                        md="10"
                    >
                      <v-list>
                        <v-list-item-title class="headline mb-1">
                          กลุ่มเป้าหมาย
                        </v-list-item-title>
                        <v-list-item class="justify-center">
                          <v-radio-group row v-model="TypeGroup">
                            <v-radio label="ตามตำแหน่ง" value="0" color="purple"></v-radio>
                            <v-radio label="กลุ่มผู้บริหาร/หัวหน้า" value="1" color="green"></v-radio>
                          </v-radio-group>
                        </v-list-item>
                        <template v-if="TypeGroup == '0'">
                          <v-list-item>
                            <v-row>
                              <v-col
                                  cols="12"
                                  md="6"
                              >
                                <v-autocomplete outlined
                                                v-model="posiCondi"
                                                :items="positions"
                                                item-text="PosName"
                                                item-value="PosCode"
                                                label="ตำแหน่ง"
                                ></v-autocomplete>
                              </v-col>
                              <v-col
                                  cols="6"
                                  md="3"
                              >
                                <v-text-field
                                    outlined
                                    type="number"
                                    v-model="workAgeStart_Condi"
                                    label="อายุงานเริ่มต้น"
                                    required
                                ></v-text-field>
                              </v-col>
                              <v-col
                                  cols="6"
                                  md="3"
                              >
                                <v-text-field
                                    outlined
                                    type="number"
                                    v-model="workAgeEnd_Condi"
                                    label="อายุงานสิ้นสุด"
                                    required
                                ></v-text-field>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item class="d-flex justify-center">
                            <v-btn
                                outlined
                                color="primary"
                                @click="DataCondiFunc"
                            >
                              เพิ่ม
                            </v-btn>
                          </v-list-item>
                          <v-list-item class="d-flex justify-center">
                            <v-data-table
                                :headers="dataHeadersCondi"
                                :items="DataCondi"
                                :search="search"
                                item-key="PosWork"
                                class="elevation-1 mt-4"
                            >
                              <template v-slot:header.PosName>
                                <v-label
                                    fontSize="16px"
                                    fontWeight="bold">
                                  เงื่อนไขตำแหน่ง, อายุงาน
                                </v-label>
                              </template>
                              <template v-slot:header.Level>
                                <v-label
                                    fontSize="16px"
                                    fontWeight="bold">
                                  ระดับ
                                </v-label>
                              </template>
                              <template v-slot:header.workAgeStart>
                                <v-label
                                    fontSize="16px"
                                    fontWeight="bold">
                                  อายุงานเริ่มต้น
                                </v-label>
                              </template>
                              <template v-slot:header.workAgeEnd>
                                <v-label
                                    fontSize="16px"
                                    fontWeight="bold">
                                  อายุงานสิ้นสุด
                                </v-label>
                              </template>
                              <template v-slot:item.PosName="{ item }">
                                <v-label>
                                  {{ item.PosName }}
                                </v-label>
                              </template>
                              <template v-slot:item.Level="{ item }">
                                <v-label>
                                  {{ item.Level }}
                                </v-label>
                              </template>
                              <template
                                  v-slot:item.workAgeStart="{ item }">
                                <v-label>
                                  {{ item.workAgeStart }} (ปี)
                                </v-label>
                              </template>
                              <template v-slot:item.workAgeEnd="{ item }">
                                <v-label>
                                  {{ item.workAgeEnd }} (ปี)
                                </v-label>
                              </template>
                              <template v-slot:item.action="{ item }">
                                <v-row class="d-flex">
                                  <v-col
                                      cols="6"
                                      md="6">
                                    <v-btn
                                        outlined
                                        color="#BF360C"
                                        @click="DeleteDataCondi(item)">
                                      ลบ
                                    </v-btn>
                                  </v-col>
                                </v-row>
                              </template>
                            </v-data-table>
                          </v-list-item>
                          <v-divider class="mt-6"></v-divider>
                          <v-list-item-title class="headline mt-6">
                            เงื่อนไขการเข้าร่วมโครงการ
                          </v-list-item-title>
                          <v-list-item>
                            <v-list-item-subtitle>
                              โควตาหน่วยงานที่เข้าร่วม
                            </v-list-item-subtitle>
                          </v-list-item>
                          <v-list-item class="d-flex justify-center">
                            <v-radio-group row v-model="ChooseTypeDep">
                              <v-radio label="หน่วยงาน/ภาควิชา" value="0"></v-radio>
                              <v-radio label="กลุ่มหน่วยงาน/กลุ่มภาควิชา" value="1"></v-radio>
                            </v-radio-group>
                          </v-list-item>
                          <v-list-item>
                            <v-row class="d-flex justify-center">
                              <v-col
                                  cols="12"
                                  md="6"
                              >
                                <v-autocomplete
                                    v-model="DepQuotaSelect"
                                    label="หน่วยงาน/ภาควิชา"
                                    :items="depart"
                                    item-text="dep_name"
                                    item-value="dep_id"
                                    persistent-hint
                                    outlined
                                    v-if="ChooseTypeDep == '0'"
                                    clearable
                                >
                                </v-autocomplete>
                                <v-autocomplete
                                    v-model="DepQuotaSelect"
                                    label="กลุ่มหน่วยงาน/กลุ่มภาควิชา"
                                    :items="groupDepart"
                                    item-text="dep_name"
                                    item-value="dep_group_id"
                                    persistent-hint
                                    outlined
                                    v-else-if="ChooseTypeDep == '1'"
                                    clearable
                                >
                                </v-autocomplete>
                                <v-autocomplete
                                    v-model="DepQuotaSelect"
                                    label="กลุ่มเทมเพลต"
                                    :items="GroupQuotaMS"
                                    item-text="group_name"
                                    item-value="id"
                                    persistent-hint
                                    outlined
                                    v-else
                                    clearable
                                >
                                </v-autocomplete>
                              </v-col>
                              <v-col
                                  cols="6"
                                  md="2"
                              >
                                <v-text-field
                                    outlined
                                    type="number"
                                    v-model="DepQuotaCount"
                                    label="จำนวน / คน"
                                    required
                                    v-if="ChooseTypeDep != '3'"
                                ></v-text-field>
                                <v-btn
                                    @click="ShowGroupDepDetail"
                                    outlined
                                    color="primary"
                                    v-else
                                >
                                  รายละเอียด
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item class="d-flex justify-center">
                            <v-btn
                                outlined
                                color="primary"
                                @click="AddDepQuotaData"
                            >
                              เพิ่ม
                            </v-btn>
                          </v-list-item>
                          <v-list-item class="d-flex justify-center">
                            <v-data-table
                                :headers="DepQuotaHeader"
                                :items="DepQuotaData"
                                :search="searchDepQuota"
                                class="elevation-1 mt-4"
                            >
                              <template v-slot:header.type>
                                <v-label
                                    fontSize="16px"
                                    fontWeight="bold">
                                  ประเภท
                                </v-label>
                              </template>
                              <template v-slot:header.dep_name>
                                <v-label
                                    fontSize="16px"
                                    fontWeight="bold">
                                  ภาควิชา/หน่วยงาน
                                </v-label>
                              </template>
                              <template v-slot:header.count>
                                <v-label
                                    fontSize="16px"
                                    fontWeight="bold">
                                  จำนวน/คน
                                </v-label>
                              </template>
                              <template v-slot:item.action="{ item }">
                                <v-row class="d-flex">
                                  <v-col
                                      cols="6"
                                      md="6">
                                    <v-btn
                                        outlined
                                        color="#BF360C"
                                        @click="DeleteDepQuotaCondi(item)">
                                      ลบ
                                    </v-btn>
                                  </v-col>
                                </v-row>
                              </template>
                              <template
                                  v-slot:footer
                              >
                                <template>
                                  <div align="center" style="margin-top: 15px">
                            <span style="font-weight: bold;color: #364eff">จำกัดหน่วยงาน : {{
                                ProjectQuotaDepCount
                              }} คน</span>
                                  </div>
                                  <div align="center" v-if="Cordi_Count == '1' && parseInt(Count) >= 0">
                            <span style="font-weight: bold;color: #ff6d81">ทั่วไป : {{
                                parseInt(Count) - parseInt(ProjectQuotaDepCount)
                              }} คน</span>
                                  </div>
                                  <div align="center" v-else>
                                    <span style="font-weight: bold;color: #ff6d81">ทั่วไป : ไม่จำกัดคน</span>
                                  </div>
                                  <div align="center" v-if="Cordi_Count == '1' && parseInt(Count) >= 0">
                              <span
                                  style="font-weight: bold;color: #42b983">รวม : {{
                                  Count
                                }} คน</span>
                                  </div>
                                  <div align="center" v-else>
                                    <span style="font-weight: bold;color: #42b983">รวม : ไม่จำกัดคน</span>
                                  </div>
                                </template>
                              </template>
                            </v-data-table>
                          </v-list-item>
                        </template>
                      </v-list>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-list-item>
          </v-list>
        </v-tab-item>
        <v-tab-item
            key="DataJoinMeeting"
        >
          <v-card>
            <v-card-title>
          <span class="font-weight-bold">
            เพิ่มข้อมูลผู้เข้าร่วมประชุม
          </span>
              <v-spacer></v-spacer>
              <v-btn
                  class="ma-2"
                  outlined
                  color="#009688"
                  @click="importExcelData('1')">
                Import ข้อมูลบุคลากร
              </v-btn>
              <v-btn
                  class="ma-2"
                  outlined
                  color="#009688"
                  @click="importExcelData('2')">
                Import ข้อมูลนักศึกษาคณะแพทย์
              </v-btn>
              <v-btn
                  class="ma-2"
                  outlined
                  color="#009688"
                  @click="importExcelData('3')">
                Import ข้อมูลบุคคลภายนอก
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-list>
                <v-list-item>
                  <v-card style="width: 100%">
                    <v-card-text>
                      <v-tabs
                          v-model="joinTab"
                          background-color="transparent"
                          color="basil"
                          show-arrows
                      >
                        <v-tabs-slider color="teal lighten-3"></v-tabs-slider>

                        <v-tab>
                          บุคลากรคณะแพทย์
                        </v-tab>
                        <v-tab>
                          นักศึกษาคณะแพทย์
                        </v-tab>
                        <v-tab>
                          บุคลากรคณะอื่น
                        </v-tab>
                        <v-tab>
                          นักศึกษาคณะอื่น
                        </v-tab>
                        <v-tab>
                          บุคคลภายนอก
                        </v-tab>
                        <v-tab>
                          นักศึกษาภายนอก
                        </v-tab>
                      </v-tabs>
                      <v-tabs-items v-model="joinTab" class="mt-4">
                        <v-tab-item>
                          <v-card>
                            <v-card-title>
                              ค้นหาบุคลากร
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                              <v-row class="d-flex justify-center">
                                <v-col
                                    cols="12"
                                    md="6">
                                  <v-autocomplete
                                      v-model="staffSel"
                                      label="ค้นหาบุคลากร"
                                      :items="staffData"
                                      item-text="customDetail"
                                      item-value="perid"
                                      hint="กด Enter เพื่อเป็นการเพิ่มข้อมูล"
                                      persistent-hint
                                      clearable
                                      outlined
                                      @keyup="checkKeyEnter"
                                  ></v-autocomplete>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="2">
                                  <v-btn
                                      class="mt-2"
                                      outlined
                                      color="primary"
                                      @click="InsertJoinMeet">
                                    เพิ่ม
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                        <v-tab-item>
                          <v-card>
                            <v-card-title>
                              นักศึกษาคณะแพทย์
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                              <v-row class="d-flex justify-center">
                                <v-col
                                    class="d-flex justify-center"
                                    cols="12"
                                    md="8">
                                  <v-autocomplete
                                      outlined
                                      :items="studentData"
                                      item-value="STUDENT_ID"
                                      item-text="fullName"
                                      v-model="Idstudent"
                                      label="ค้นหา ชื่อ - สกุล รหัสนักศึกษา"
                                  >
                                  </v-autocomplete>
                                  <v-btn
                                      style="margin-left: 20px;margin-top: 15px"
                                      color="primary"
                                      outlined
                                      @click="insertStd('med')">
                                    บันทึก
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                        <v-tab-item>
                          <v-card>
                            <v-card-title>
                              บุคลากรคณะอื่น
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                              <v-row class="d-flex justify-center">
                                <v-col
                                    class="d-flex justify-center"
                                    cols="12"
                                    md="8">
                                  <v-autocomplete
                                      outlined
                                      :items="AllDepartData"
                                      item-value="FAC_ID"
                                      item-text="FAC_NAME_THAI"
                                      v-model="IdDepart"
                                      label="ค้นหาคณะ/สังกัด"
                                      @change="GetPersonalPSU"
                                  >
                                  </v-autocomplete>
                                </v-col>
                              </v-row>
                            </v-card-text>
                            <v-card-text>
                              <v-row class="d-flex justify-center">
                                <v-col
                                    class="d-flex justify-center"
                                    cols="12"
                                    md="8">
                                  <v-autocomplete
                                      outlined
                                      :items="personalMedData"
                                      item-value="STAFF_ID"
                                      item-text="FULL_NAME"
                                      v-model="IdPersonal"
                                      label="ค้นหา ชื่อ - สกุล รหัสบุคลากร"
                                  >
                                  </v-autocomplete>
                                  <v-btn
                                      style="margin-left: 20px;margin-top: 15px"
                                      color="primary"
                                      outlined
                                      @click="insertPersonUni()">
                                    บันทึก
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                        <v-tab-item>
                          <v-card>
                            <v-card-title>
                              นักศึกษาคณะอื่น
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                              <v-row class="d-flex justify-center">
                                <v-col
                                    class="d-flex justify-center"
                                    cols="12"
                                    md="8">
                                  <v-autocomplete
                                      outlined
                                      :items="AllDepartData"
                                      item-value="FAC_ID"
                                      item-text="FAC_NAME_THAI"
                                      v-model="IdDepartStd"
                                      label="ค้นหาคณะ"
                                      @change="GetStdPSU"
                                  >
                                  </v-autocomplete>
                                </v-col>
                              </v-row>
                            </v-card-text>
                            <v-card-text>
                              <v-row class="d-flex justify-center">
                                <v-col
                                    class="d-flex justify-center"
                                    cols="12"
                                    md="8">
                                  <v-autocomplete
                                      outlined
                                      :items="studentUniData"
                                      item-value="STUDENT_ID"
                                      item-text="fullName"
                                      v-model="IdstudentUni"
                                      label="ค้นหา ชื่อ - สกุล รหัสนักศึกษา"
                                  ></v-autocomplete>
                                  <v-btn
                                      style="margin-left: 20px;margin-top: 15px"
                                      color="primary"
                                      outlined
                                      @click="insertStd('other')">
                                    บันทึก
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                        <v-tab-item>
                          <v-card>
                            <v-card-title>
                              บุคคลภายนอก
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                              <v-row class="d-flex justify-center">
                                <v-col
                                    cols="12"
                                    md="8">
                                  <v-row>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <v-text-field
                                          v-model="NameP"
                                          label="ชื่อ (name)"
                                          :error-messages="NameP == '' ? '*' : ''"
                                          :error="NameP == ''"
                                      >
                                      </v-text-field>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <v-text-field
                                          v-model="SurNameP"
                                          label="สกุล (surname)"
                                          :error-messages="SurNameP == '' ? '*' : ''"
                                          :error="SurNameP == ''"
                                      >
                                      </v-text-field>
                                    </v-col>
                                  </v-row>
                                  <v-row>
                                    <v-col
                                        cols="12"
                                        md="4">
                                      <v-text-field
                                          v-model="idCard"
                                          label="รหัสบัตรประชาชน"
                                          :error-messages="idCard == '' ? '*' : ''"
                                          :error="idCard == ''"
                                      >
                                      </v-text-field>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="4">
                                      <v-text-field
                                          v-model="affiliation"
                                          label="สังกัด"
                                      >
                                      </v-text-field>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="4">
                                      <v-text-field
                                          v-model="position"
                                          label="ตำแหน่ง"
                                      >
                                      </v-text-field>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                              <v-list-item>
                                <v-row class="justify-center">
                                  <v-col
                                      cols="12"
                                      md="4">
                                    <v-text-field label="เบอร์โทร" v-model="phoneOther" text></v-text-field>
                                  </v-col>
                                </v-row>
                              </v-list-item>
                              <v-list-item
                                  class="d-flex justify-center"
                              >
                                <v-btn
                                    color="primary"
                                    outlined
                                    @click="insertDataPerson('person')">
                                  บันทึก
                                </v-btn>
                              </v-list-item>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                        <v-tab-item>
                          <v-card>
                            <v-card-title>
                              นักศึกษาภายนอก
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                              <v-row class="d-flex justify-center">
                                <v-col
                                    cols="12"
                                    md="8">
                                  <v-row>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <v-text-field
                                          v-model="NameStd"
                                          label="ชื่อ (name)"
                                          :error-messages="NameStd == '' ? '*' : ''"
                                          :error="NameStd == ''"
                                      >
                                      </v-text-field>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <v-text-field
                                          v-model="SurNameStd"
                                          label="สกุล (surname)"
                                          :error-messages="SurNameStd == '' ? '*' : ''"
                                          :error="SurNameStd == ''"
                                      >
                                      </v-text-field>
                                    </v-col>
                                  </v-row>
                                  <v-row>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <v-text-field
                                          v-model="idCardStd"
                                          label="รหัสบัตรประชาชน"
                                          :error-messages="idCardStd == '' ? '*' : ''"
                                          :error="idCardStd == ''"
                                      >
                                      </v-text-field>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <v-text-field
                                          v-model="affiliationStd"
                                          label="มหาวิทยาลัย"
                                      >
                                      </v-text-field>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                              <v-list-item>
                                <v-row class="justify-center">
                                  <v-col
                                      cols="12"
                                      md="4">
                                    <v-text-field label="เบอร์โทร" v-model="phoneOther" text></v-text-field>
                                  </v-col>
                                </v-row>
                              </v-list-item>
                              <v-list-item
                                  class="d-flex justify-center"
                              >
                                <v-btn
                                    color="primary"
                                    outlined
                                    @click="insertDataPerson('Std')">
                                  บันทึก
                                </v-btn>
                              </v-list-item>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-card-text>
                  </v-card>
                </v-list-item>
                <v-list-item>
                  <v-spacer></v-spacer>
                  <v-text-field v-model="search" label="ค้นหา"></v-text-field>
                </v-list-item>
                <v-list-item class="d-flex justify-center mt-6">
                  <v-data-table
                      style="width: 100%"
                      :search="search"
                      :headers="JoinMeetHeader"
                      :items="JoinMeet">
                    <template v-slot:item.type="{item}">
                                                            <span v-if="item.registerType_id == '0'"
                                                                  style="color: #ff6d81">
                                                                บุคลากรคณะแพทย์
                                                            </span>
                      <span v-if="item.registerType_id == '1'" style="color: #ff6d81">
                                                                นักศึกษาคณะแพทย์
                                                            </span>
                      <span v-if="item.registerType_id == '2'" style="color: blue">
                                                                บุคลากรคณะอื่น
                                                            </span>
                      <span v-if="item.registerType_id == '3'" style="color: blue">
                                                                นักศึกษาคณะอื่น
                                                            </span>
                      <span v-if="item.registerType_id == '4'" style="color: darkslateblue">
                                                                บุคคลภายนอก
                                                            </span>
                      <span v-if="item.registerType_id == '5'" style="color: darkslateblue">
                                                                นักศึกษาภายนอก
                                                            </span>
                    </template>
                    <template v-slot:item.action="{item}">
                      <v-btn color="red"
                             @click="DelData(item.idx)"
                             outlined
                      >
                        ลบ
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
      <div align="center" class="mt-2" style="border: 1px solid black;background-color: white">
        <v-list-item class="d-flex justify-center">
          <v-btn outlined color="green" @click="InsertMeetingData">
            เพิ่มข้อมูลจัดประชุม
          </v-btn>
        </v-list-item>
      </div>
    </v-container>
    <v-dialog
        v-model="dialogLoading"
        persistent
        width="300"
    >
      <v-card
          color="primary"
          dark
      >
        <v-card-text>
          Loading...
          <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="DialogImportEmp"
        persistent
        max-width="500"
    >
      <v-card>
        <v-card-title>
           <span
               style="font-weight: bold;color: #364eff">Import {{ typeImport == '1' ? 'ข้อมูลบุคลากร' : typeImport == '2' ? 'ข้อมูลนักศึกษาคณะแพทย์' : "ข้อมูลบุคคลภายนอก" }}</span>
        </v-card-title>
        <v-card-text>
          <v-list>
            <v-list-item class="d-flex justify-center mt-6">
              <v-btn text color="primary" @click="downloadTemplateEmp">ดาวน์โหลด Template ตัวอย่าง</v-btn>
            </v-list-item>
            <v-list-item class="mt-6">
              <v-file-input
                  v-model="filesImportEmp"
                  color="deep-purple accent-4"
                  counter
                  multiple
                  label="แนบไฟล์ (ถ้ามี)"
                  placeholder="เลือกไฟล์"
                  prepend-icon="mdi-paperclip"
                  outlined
                  :show-size="1000"
                  @change="FileImport"
              >
                <template v-slot:selection="{ index, text }">
                  <v-chip
                      v-if="index < 5"
                      color="deep-purple accent-4"
                      dark
                      label
                      small
                  >
                    {{ text }}
                  </v-chip>

                  <span
                      v-else-if="index === 5"
                      class="overline grey--text text--darken-3 mx-2"
                  >
                                +{{ filesImportEmp.length - 2 }} File(s)
                              </span>
                </template>
              </v-file-input>
            </v-list-item>

            <v-list-item v-if="sheets.length > 0">
              <v-select
                  v-model="ChooseSheet"
                  label="เลือก Sheets"
                  :items="sheets"
                  item-text="name"
                  item-value="name"
                  @change="ChooseSheetAction"
              >

              </v-select>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="closeDi_ImportDataEmp">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="DialogExamImportEmp"
        persistent
        fullscreen
        scrollable
    >
      <v-card>
        <v-toolbar
            dark
            color="primary"
        >
          <v-btn
              icon
              dark
              @click="closeDi_ImportDataEmp"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title><span style="font-weight: bold">ตัวอย่างข้อมูลที่ต้องการนำเข้า</span></v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
                dark
                style="background-color: black"
                text
                class="text-h4"
                @click="ImportDataToDb"
            >
              นำเข้าข้อมูล
            </v-btn>
            <v-btn
                dark
                text
                style="background-color: red"
                @click="closeDi_ImportDataEmp"
                class="text-h4"
            >
              ปิด
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text style="height: 100%" class="mt-6">
          <v-list>
            <v-list-item>
              <v-data-table
                  :headers="empHeadersAfter"
                  :items="empData"
                  class="elevation-2"
                  dense
                  style="width: 100%"
              >
                <template v-slot:item.registerType_id="{item}">
                                                            <span v-if="item.registerType_id == '0'"
                                                                  style="color: #ff6d81">
                                                                บุคลากรคณะแพทย์
                                                            </span>
                  <span v-if="item.registerType_id == '1'" style="color: #ff6d81">
                                                                นักศึกษาคณะแพทย์
                                                            </span>
                  <span v-if="item.registerType_id == '2'" style="color: blue">
                                                                บุคลากรคณะอื่น
                                                            </span>
                  <span v-if="item.registerType_id == '3'" style="color: blue">
                                                                นักศึกษาคณะอื่น
                                                            </span>
                  <span v-if="item.registerType_id == '4'" style="color: darkslateblue">
                                                                บุคคลภายนอก
                                                            </span>
                  <span v-if="item.registerType_id == '5'" style="color: darkslateblue">
                                                                นักศึกษาภายนอก
                                                            </span>
                </template>
                <template v-slot:item.status_reg="{item}">
                      <span style="font-weight: bold;color: red" v-if="item.status_reg == '0'">
                        รอลงทะเบียน
                      </span>
                  <span style="font-weight: bold;color: forestgreen" v-else>
                        ลงทะเบียนเข้าร่วม
                      </span>
                </template>
                <template v-slot:item.action="{item}">
                  <v-btn
                      color="#F44336"
                      outlined
                      @click="Del_item_ImportEmp(item.idEmp)">
                    ลบ
                  </v-btn>
                </template>
              </v-data-table>
            </v-list-item>
            <div align="center" style="margin-top: 30px">
              <v-alert
                  dense
                  outlined
                  type="error"
                  dismissible
                  v-if="ShowAlertErrImp"
              >
                <div v-html="MessageErrorImp"></div>
              </v-alert>
            </div>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-content>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import axios from "axios";
import ConstData from "@/const/Const";
// var shortUrl = require('node-url-shortener');
var TinyURL = require('tinyurl');
import CopyToClipboard from 'vue-copy-to-clipboard'
import readXlsxFile from "read-excel-file";

export default {
  name: "ManageMeeting",
  components: {
    CopyToClipboard
  },
  data() {
    return {
      typeImport: null,
      empHeaders: [],
      empHeadersAfter: [
        {text: 'รหัส', value: 'uid'},
        {text: 'ชื่อ - สกุล', value: 'full_Name'},
        {text: 'สังกัด', value: 'affiliation'},
        {text: 'ประเภท', value: 'registerType_id'},
        {text: 'สถานะลงทะเบียน', value: 'status_reg'},
        {text: '', value: 'action'}
      ],
      empData: [],
      sheets: [],
      ChooseSheet: '',
      Exec: false,
      Openfile: ConstData.ConnectionHost + '/rest/files',
      dialogFile: false,
      DialogImportEmp: false,
      DialogExamImportEmp: false,
      personObj: null,
      alertP: false,
      ShowAlertErrImp: false,
      MessageErrorImp: '',
      txtAlertP: [],
      filesP: [],
      filesImportEmp: [],
      phoneOther: '',
      NameP: '',
      SurNameP: '',
      affiliation: '',
      position: '',
      idCard: '',
      NameStd: '',
      SurNameStd: '',
      affiliationStd: '',
      idCardStd: '',
      studentData: [],
      studentUniData: [],
      IdDepartStd: '',
      IdDepart: '',
      Idstudent: '',
      IdstudentUni: '',
      IdPersonal: '',
      personalMedData: [],
      AllDepartData: [],
      joinTab: null,
      ChkCordiMeeting: '0',
      TypeGroup: '0',
      groupDepart: [],
      dateRegStart: '',
      dateRegEnd: '',
      ProjectQuotaDepCount: 0,
      DepQuotaData: [],
      searchDepQuota: '',
      DepQuotaCount: '',
      DepQuotaSelect: '',
      ChooseTypeDep: '0',
      ChooseTypRegis: '1',
      ChooseTypRegis2: '0',
      ChkJoinPerson: true,
      ProjectQuotaCount: '',
      DepQuotaHeader: [
        {text: 'ประเภท', value: 'type'},
        {text: 'ภาควิชา/หน่วยงาน', value: 'dep_name'},
        {text: 'จำนวน', value: 'count'},
        {text: '', value: 'action'},
      ],
      dataHeadersCondi: [
        {text: 'ตำแหน่ง', value: 'PosName'},
        {text: 'อายุงานเริ่มต้น', value: 'workAgeStart'},
        {text: 'อายุงานสิ้นสุด', value: 'workAgeEnd'},
        {text: '', value: 'action'},
      ],
      DataCondi: [],
      workAgeStart_Condi: '',
      workAgeEnd_Condi: '',
      posiCondi: '',
      Register_Cordi: '0',
      Register_Cordi2: '0',
      dialogLoading: false,
      DepartDump: [],
      codePermiss: '11001',
      CheckAdmin: false,
      CheckSubAdmin: false,
      Rm: '',
      files: [],
      alert: false,
      txtAlert: [],
      FileMeeting: [],
      search: '',
      staffSel: '',
      tab: 'DataMeeting',
      Topic: '',
      Count: '0',
      Date_start: '',
      Date_reg_start: '',
      Date_end: '',
      Date_reg_end: '',
      Time_start: '',
      Time_end: '',
      DepSelect: '',
      Place: '',
      LinkGen: '',
      url: '',
      Cordi_Count: '0',
      headerAxios: {
        headers: {
          'Content-Type': 'application/json',
        }
      },
      headerAxiosPUT: {
        headers: {
          'X-REST-METHOD': 'PUT'
        }
      },
      JoinMeetHeader: [
        {text: 'รหัสอ้างอิง', value: 'uid'},
        {text: 'ชื่อ - สกุล', value: 'full_Name'},
        {text: 'สังกัด', value: 'affiliation'},
        {text: 'ประเภท', value: 'type'},
        {text: '', value: 'action'}
      ],
      JoinMeet: []
    }
  },
  computed: {
    ...mapGetters({
      MeData: 'Staff/getMeData',
      staffData: 'Staff/getStaff',
      positions: 'Staff/getPosition',
      depart: 'Depart/getDepart',
      GroupQuotaMS: 'Project/getGroupQuota_Ms',
      Permission_Dep_User: 'Permission/getPermissionDepUser',
      Permission_Dep: 'Permission/getPermissionDep',
      PermissionAdmin: 'Permission/getPermission',
      Permission: 'Permission/getPermissionUser',
    })
  },
  watch: {
    // LinkGen: function () {
    //   shortUrl.short('https://medhr.medicine.psu.ac.th/JoinMeeting/' + this.LinkGen, (err, url) => {
    //     if (url != null) {
    //       if (this.url == '') {
    //         this.url = url
    //         console.log(this.url)
    //       }
    //     }
    //   });
    // },
  },
  methods: {
    ...mapActions({
      initMeData: 'Staff/initMeData',
      initDepartData: 'Depart/initDepartData',
      initStaffData: 'Staff/initStaffData',
      initPositionsData: 'Staff/initPositionsData',
      initGroup_Quota_Ms: 'Project/initGroup_Quota_Ms',
      getPermissionDep: 'Permission/getPermissionDepData',
      getPermissionDepUserData: 'Permission/getPermissionDepUserData',
      getPermissionUserData: 'Permission/getPermissionUserData',
      getPermissionData: 'Permission/getPermissionData',
    }),
    init() {
      this.dialogLoading = true
      this.DepartDump = []
      this.LinkGen = this.$uuid.v1()
      this.initPositionsData()
      this.initGroup_Quota_Ms()
      this.initDepartData().then(res => {
        if (res) {
          if (this.depart.length > 0) {
            this.groupDepart = this.UniqueArraybyId(this.depart, 'dep_group_name')
          }
        }
      })
      this.GenerateUrl().then(res => {
        this.url = res
      })
      if (this.CheckAdmin) {
        this.getPermissionDep({
          perid: this.MeData[0].perid
        }).then(resDep => {
          if (resDep) {
            if (this.depart.length > 0) {
              if (this.Permission_Dep.length > 0) {
                this.Permission_Dep.map(Dep => {
                  this.depart.map(Dep2 => {
                    if (Dep2.dep_id == Dep.dep_id) {
                      this.DepartDump.push({
                        ...Dep2
                      })
                    }
                  })
                })
              }
            }
            this.dialogLoading = false
          } else {
            this.dialogLoading = false
          }
        })
      } else if (this.CheckSubAdmin) {
        this.getPermissionDepUserData({
          perid: this.MeData[0].perid
        }).then(resDep => {
          if (resDep) {
            if (this.depart.length > 0) {
              if (this.Permission_Dep.length > 0) {
                this.Permission_Dep.map(Dep => {
                  this.depart.map(Dep2 => {
                    if (Dep2.dep_id == Dep.dep_id) {
                      this.DepartDump.push({
                        ...Dep2
                      })
                    }
                  })
                })
              }
            }
            this.dialogLoading = false
          } else {
            this.dialogLoading = false
          }
        })
      }

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/stdMed/STUDENT/FAC_ID/09/STUDY_STATUS/OK/?limit=99999').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map(item => {
              this.studentData.push({
                ...item,
                fullName: 'รหัสนักศึกษา : ' + item.STUDENT_ID + ' ชื่อ-สกุล ' + item.STUD_NAME_THAI + ' ' + item.STUD_SNAME_THAI
              })
            })
          } else {
            this.studentData.push({
              ...res.data,
              fullName: 'รหัสนักศึกษา : ' + res.data[0].STUDENT_ID + ' ชื่อ-สกุล ' + res.data[0].STUD_NAME_THAI + ' ' + res.data[0].STUD_SNAME_THAI
            })
          }
        } else {
          this.studentData = []
        }
      })

      axios.get(ConstData.ConnectionHost + '/rest/v1/AllPersonal/dss_person.W_FACULTY/1').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            this.AllDepartData = res.data
          } else {
            this.AllDepartData.push(res.data)
          }
        } else {
          this.AllDepartData = []
        }
      })
    },
    GetStdPSU() {
      this.studentUniData = []
      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/stdMed/STUDENT2_view/FAC_ID/' + this.IdDepartStd + '/?sort=STUDENT_ID_ASC&limit=99999').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map(item => {
              this.studentUniData.push({
                ...item,
                fullName: 'รหัสนักศึกษา : ' + item.STUDENT_ID + ' ชื่อ-สกุล ' + item.STUD_NAME_THAI + ' ' + item.STUD_SNAME_THAI
              })
            })
          } else {
            this.studentUniData.push({
              ...res.data,
              fullName: 'รหัสนักศึกษา : ' + res.data[0].STUDENT_ID + ' ชื่อ-สกุล ' + res.data[0].STUD_NAME_THAI + ' ' + res.data[0].STUD_SNAME_THAI
            })
          }
        } else {
          this.studentUniData = []
        }
      })
    },
    GetPersonalPSU() {
      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrstd/V_STAFF/FAC_ID/' + this.IdDepart + '/?sort=STAFF_ID_ASC&limit=99999').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map(item => {
              this.personalMedData.push({
                ...item,
                FULL_NAME: '(' + item.STAFF_ID + ') ' + item.STAFF_NAME_THAI + ' ' + item.STAFF_SNAME_THAI
              })
            })
          } else {
            this.personalMedData.push(res.data)
          }
        } else {
          this.personalMedData = []
        }
      })
    },
    CheckPermission() {
      return new Promise(resolve => {
        var CheckPermiss = false
        if (this.PermissionAdmin.length > 0) {
          this.PermissionAdmin.map((Per_i, idx) => {
            if (Per_i.permission_id == this.codePermiss) {
              resolve(true)
            } else {
              if (!CheckPermiss && idx == this.PermissionAdmin.length - 1) {
                resolve(false)
              }
            }
          })
        } else {
          this.Permission.map((Per_i, idx) => {
            if (Per_i.permission_id == this.codePermiss) {
              resolve(true)
            } else {
              if (!CheckPermiss && idx == this.Permission.length - 1) {
                resolve(false)
              }
            }
          })
        }
      })
    },
    UniqueArraybyId(collection, keyname) {
      var output = [],
          keys = [];

      collection.map((item) => {
        var key = item[keyname];
        if (keys.indexOf(key) === -1) {
          keys.push(key);
          output.push(item);
        }
      });
      return output;
    },
    AddDepQuotaData() {
      var CheckMatch = false
      var Depart = []
      var type = ''
      if (this.ChooseTypeDep == '3') {

        var count = this.GroupQuotaData.reduce((prev, cur) => prev + parseInt(cur.count), 0)

        if (this.Cordi_Count == '1' && ((parseInt(count) + parseInt(this.ProjectQuotaDepCount)) > parseInt(this.Count))) {
          this.$swal.fire({
            icon: 'error',
            title: 'ไม่สามารถบันทึกโควต้าข้อมูลหน่วยงานได้เนื่องจากเกินจำนวนผู้เข้าร่วมที่กำหนด'
          })
        } else {
          this.GroupQuotaData.map((Group_I, idx) => {
            CheckMatch = false
            if (this.DepQuotaData.length > 0) {
              this.DepQuotaData.map(itemDepQ => {
                if (itemDepQ.type_id == '0') {
                  if (Group_I.dep_id == itemDepQ.dep_id) {
                    CheckMatch = true
                  }
                } else {
                  Depart = this.depart.filter(item => item.dep_group_id == itemDepQ.dep_group_id)
                  if (Depart.filter(item => item.dep_id == Group_I.dep_id).length > 0) {
                    CheckMatch = true
                  }
                }
              })

              if (!CheckMatch) {
                this.DepQuotaData.push({
                  quotaType: '0',
                  type: 'หน่วยงาน/ภาควิชา',
                  type_id: '0',
                  dep_name: this.depart.filter(item => item.dep_id == Group_I.dep_id)[0].dep_name,
                  dep_id: this.depart.filter(item => item.dep_id == Group_I.dep_id)[0].dep_id,
                  dep_group_id: this.depart.filter(item => item.dep_id == Group_I.dep_id)[0].dep_group_id,
                  count: Group_I.count
                })

                this.ProjectQuotaDepCount += parseInt(Group_I.count)
              }
            } else {
              this.DepQuotaData.push({
                quotaType: '0',
                type: 'หน่วยงาน/ภาควิชา',
                type_id: '0',
                dep_name: this.depart.filter(item => item.dep_id == Group_I.dep_id)[0].dep_name,
                dep_id: this.depart.filter(item => item.dep_id == Group_I.dep_id)[0].dep_id,
                dep_group_id: this.depart.filter(item => item.dep_id == Group_I.dep_id)[0].dep_group_id,
                count: Group_I.count
              })

              this.ProjectQuotaDepCount += parseInt(Group_I.count)
            }

            if (idx == this.GroupQuotaData.length - 1) {
              this.GroupSelect = ''
            }
          })

        }

        ///////////////////////////////////////////////////////

      } else {
        if (this.DepQuotaSelect != '' && this.DepQuotaCount != '') {
          if (this.Cordi_Count == '1' && ((parseInt(this.DepQuotaCount) + parseInt(this.ProjectQuotaDepCount)) > parseInt(this.Count))) {
            this.$swal.fire({
              icon: 'error',
              title: 'ไม่สามารถบันทึกโควต้าข้อมูลหน่วยงานได้เนื่องจากเกินจำนวนผู้เข้าร่วมที่กำหนด'
            })
          } else {
            if (parseInt(this.DepQuotaCount) > 0) {
              if (this.DepQuotaData.length > 0) {
                this.DepQuotaData.map(itemDepQ => {
                  if (itemDepQ.type_id == '0') {
                    if (this.ChooseTypeDep == '0') {
                      if (this.DepQuotaSelect == itemDepQ.dep_id) {
                        CheckMatch = true
                      }
                    } else {
                      Depart = this.depart.filter(item => item.dep_group_id == this.DepQuotaSelect)
                      if (Depart.filter(item => item.dep_id == itemDepQ.dep_id).length > 0) {
                        CheckMatch = true
                      }
                    }
                  } else {
                    Depart = this.depart.filter(item => item.dep_group_id == itemDepQ.dep_group_id)
                    if (Depart.filter(item => item.dep_id == this.DepQuotaSelect).length > 0) {
                      CheckMatch = true
                    }
                  }
                })

                if (CheckMatch) {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'พบข้อมูลหน่วยงาน อยู่แล้วไม่สามารถบันทึกข้อมูลหน่วยงานเพิ่มได้อีก'
                  })
                } else {
                  if (this.ChooseTypeDep == '0') {
                    type = 'หน่วยงาน/ภาควิชา'
                  } else {
                    type = 'กลุ่มหน่วยงาน/กลุ่มภาควิชา'
                  }
                  this.DepQuotaData.push({
                    quotaType: this.ChooseTypeDep,
                    type: type,
                    type_id: this.ChooseTypeDep,
                    dep_name: this.depart.filter(item => item.dep_id == this.DepQuotaSelect)[0].dep_name,
                    dep_id: this.depart.filter(item => item.dep_id == this.DepQuotaSelect)[0].dep_id,
                    dep_group_id: this.depart.filter(item => item.dep_id == this.DepQuotaSelect)[0].dep_group_id,
                    count: this.DepQuotaCount
                  })

                  this.ProjectQuotaDepCount += parseInt(this.DepQuotaCount)
                  this.DepQuotaSelect = ''
                  this.DepQuotaCount = ''
                }
              } else {
                if (this.ChooseTypeDep == '0') {
                  type = 'หน่วยงาน/ภาควิชา'
                } else {
                  type = 'กลุ่มหน่วยงาน/กลุ่มภาควิชา'
                }
                this.DepQuotaData.push({
                  quotaType: this.ChooseTypeDep,
                  type: type,
                  type_id: this.ChooseTypeDep,
                  dep_name: this.depart.filter(item => item.dep_id == this.DepQuotaSelect)[0].dep_name,
                  dep_id: this.depart.filter(item => item.dep_id == this.DepQuotaSelect)[0].dep_id,
                  dep_group_id: this.depart.filter(item => item.dep_id == this.DepQuotaSelect)[0].dep_group_id,
                  count: this.DepQuotaCount
                })

                this.ProjectQuotaDepCount += parseInt(this.DepQuotaCount)
                this.DepQuotaSelect = ''
                this.DepQuotaCount = ''
              }
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'กรุณาระบุจำนวนผู้เข้าร่วมอย่างน้อย 1 คน'
              })
            }
          }
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'กรุณาระบุข้อมูลหน่วยงาน และจำนวนผู้เข้าร่วมให้ครบถ้วน'
          })
        }
      }
    },
    RemoveJoinProject() {
      if (this.JoinPerson.length > 0) {
        this.JoinPerson = []
      }
    },
    DeleteDataCondi(DataCor) {
      this.DataCondi.map((item, index) => {
        if (item.PosCode == DataCor.PosCode) {
          this.DataCondi.splice(index, 1)
        }
      })
    },
    DeleteDepQuotaCondi(DataCor) {
      this.ProjectQuotaDepCount -= parseInt(DataCor.count)
      this.DepQuotaData.map((item, index) => {
        if (item.dep_id == DataCor.dep_id) {
          this.DepQuotaData.splice(index, 1)
        }
      })
    },
    DataCondiFunc() {
      var CheckDupe = false
      if (this.workAgeStart_Condi > this.workAgeEnd_Condi) {
        this.$swal.fire({
          icon: 'error',
          title: 'พบข้อผิดพลาด คุณกรอกอายุงานไม่ถูกต้อง'
        })
      } else if (this.workAgeStart_Condi == '' || this.workAgeEnd_Condi == '') {
        this.$swal.fire({
          icon: 'error',
          title: 'พบข้อผิดพลาด โปรดกรอกอายุงานให้ครบถ้วน'
        })
      } else {
        this.DataCondi.map((item) => {
          if (item.PosCode == this.posiCondi) {
            if (this.workAgeStart_Condi >= item.workAgeStart && this.workAgeStart_Condi <= item.workAgeEnd) {
              CheckDupe = true
            } else if (this.workAgeEnd_Condi >= item.workAgeStart && this.workAgeEnd_Condi <= item.workAgeEnd) {
              CheckDupe = true
            }
          }
        })
        if (CheckDupe) {
          this.$swal.fire({
            icon: 'error',
            title: 'พบข้อผิดพลาด อายุงานที่เลือก มีในระบบอยู่แล้ว โปรดตรวจสอบข้อมูลอายุงาน'
          })
        } else {
          this.positions.map((item) => {
            if (item.PosCode == this.posiCondi) {
              this.DataCondi.push({
                ...item,
                workAgeStart: this.workAgeStart_Condi,
                workAgeEnd: this.workAgeEnd_Condi,
              })
            }
          })
          this.posiCondi = ''
          this.levelCondi = ''
          this.workAgeStart_Condi = ''
          this.workAgeEnd_Condi = ''
          this.Course_Choose = ''
        }
      }

    },
    ShowData: function (dataUrl) {
      window.open(
          dataUrl,
          '_blank' // <- This is what makes it open in a new window.
      );

    },
    FileSelect: function () {
      // var count = 0
      this.txtAlert = []
      this.FileMeeting = []
      this.alert = false
      if (this.files.length > 0) {
        this.files.map((item) => {
          var Checkfile = false;
          switch (item.type) {
            case 'image/jpg':
            case 'image/jpeg':
            case 'image/gif':
            case 'image/bmp':
            case 'image/png':
              Checkfile = true;
              break
            case 'application/pdf':
              Checkfile = true;
              break
            default:
              Checkfile = false;
              break
          }

          if (Checkfile) {
            if (item.size > 2048 * 2048) {
              this.txtAlert.push({
                id: this.txtAlert.length + 1,
                Detail: 'ไฟล์ ' + item.name + ' ขนาดเกิน 4 mb*'
              })
            }
          } else {
            this.txtAlert.push({
              id: this.txtAlert.length + 1,
              Detail: 'ไม่สนับสนุนนามสกุลไฟล์ ' + item.type.split('/')[1] + ' ( ' + item.name + ' ) '
            })
          }
        })
      }

      if (this.txtAlert.length == 0) {
        this.files.map((item) => {
          const fd = new FormData()
          fd.append('file', item, item.name)
          const headerAxios = {
            headers: {
              'Content-Type': 'multipart/form-data',
              'WithCredentials': true,
              "Access-Control-Allow-Origin": "*"
              // "Accept": 'multipart/form-data'
            }
          }

          axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, headerAxios).then(res => {
            if (res.data.status) {
              switch (item.type) {
                case 'image/jpg':
                case 'image/jpeg':
                case 'image/gif':
                case 'image/bmp':
                case 'image/png':
                  this.FileMeeting.push({
                    name: item.name,
                    src: URL.createObjectURL(item),
                    path: res.data.path,
                    type: 'image',
                    type_Img: item.type
                  })
                  break
                case 'application/pdf':
                  this.FileMeeting.push({
                    name: item.name,
                    src: URL.createObjectURL(item),
                    path: res.data.path,
                    type: 'pdf',
                    type_Img: item.type
                  })
                  break
                default:
                  break
              }

              // count++
              //
              // if (count === this.files.length) {
              //     this.FileMeetingPdf = []
              //     this.FileMeeting = []
              // }
            }
          })
        })

      } else {
        this.alert = true
      }

    },
    DelData(idx) {
      this.JoinMeet.map((item, idx2) => {
        if (item.idx == idx) {
          this.JoinMeet.splice(idx2, 1)
        }
      })
      this.staffSel = ''
    },
    insertDataPerson(type) {
      var CheckDupe = false
      if (type == 'person') {

        if (this.NameP == '' || this.SurNameP == '' || this.idCard == '') {
          this.$swal.fire({
            icon: 'error',
            title: 'พบข้อผิดพลาด กรุณรากรอกข้อมูลให้ครบถ้วน'
          })
        } else {
          if (this.JoinMeet.filter(item => item.uid == ('P_' + this.JoinMeet.length)).length > 0) {
            CheckDupe = true
          }
          if (!CheckDupe) {
            this.JoinMeet.unshift({
              uid: 'P_' + this.JoinMeet.length,
              full_Name: this.NameP + ' ' + this.SurNameP,
              name: this.NameP,
              sname: this.SurNameP,
              idCard: this.idCard,
              affiliation: this.affiliation,
              position: this.position,
              phone: this.phoneOther,
              registerType_id: 4,
              status_reg: '0',
              files: [],
              type_details: 'บุคคลภายนอก'
            })
            this.NameP = ''
            this.SurNameP = ''
            this.idCard = ''
            this.affiliation = ''
            this.position = ''
            this.phoneOther = ''
          } else {
            this.$swal.fire({
              icon: 'error',
              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
            })
          }
        }
      } else {
        if (this.NameStd == '' || this.SurNameStd == '' || this.idCardStd == '') {
          this.$swal.fire({
            icon: 'error',
            title: 'พบข้อผิดพลาด กรุณรากรอกข้อมูลให้ครบถ้วน'
          })
        } else {
          if (this.JoinMeet.filter(item => item.uid == ('S_' + this.JoinMeet.length)).length > 0) {
            CheckDupe = true
          }
          if (!CheckDupe) {
            this.JoinMeet.unshift({
              uid: 'S_' + this.JoinMeet.length,
              full_Name: this.NameStd + ' ' + this.SurNameStd,
              name: this.NameStd,
              sname: this.SurNameStd,
              idCard: this.idCardStd,
              affiliation: this.affiliationStd,
              position: '',
              phone: this.phoneOther,
              registerType_id: 5,
              status_reg: '0',
              files: [],
              type_details: 'นักศึกษาภายนอก'
            })
            this.NameStd = ''
            this.SurNameStd = ''
            this.idCardStd = ''
            this.affiliationStd = ''
            this.phoneOther = ''
          } else {
            this.$swal.fire({
              icon: 'error',
              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
            })
          }
        }
      }
    },
    InsertJoinMeet() {
      if (this.JoinMeet.length > 0) {
        if (this.JoinMeet.filter(item => item.perid == this.staffSel).length > 0) {
          this.staffSel = ''
          this.$swal.fire({
            icon: 'error',
            title: 'พบข้อผิดพลาด บุคลากรที่เลือกมีข้อมูลอยู่แล้ว!!'
          })
        } else {
          var Staff = this.staffData.filter(item => item.perid == this.staffSel)
          if (Staff.length > 0) {
            this.JoinMeet.unshift({
              ...Staff[0],
              uid: Staff[0].perid,
              name: Staff[0].name,
              sname: Staff[0].surname,
              idCard: Staff[0].citizen_id,
              affiliation: Staff[0].dep_name,
              position: Staff[0].pos_name,
              phone: '',
              registerType_id: 0,
              status_reg: '0',
              type_details: 'บุคลากรคณะแพทย์'
            })
            this.JoinMeet.map((item, idx) => {
              item.idx = idx + 1
            })
          }
        }
      } else {
        Staff = this.staffData.filter(item => item.perid == this.staffSel)
        if (Staff.length > 0) {
          this.JoinMeet.unshift({
            ...Staff[0],
            uid: Staff[0].perid,
            name: Staff[0].name,
            sname: Staff[0].surname,
            idCard: Staff[0].citizen_id,
            affiliation: Staff[0].dep_name,
            position: Staff[0].pos_name,
            phone: '',
            registerType_id: 0,
            status_reg: '0',
            type_details: 'บุคลากรคณะแพทย์'
          })
          this.JoinMeet.map((item, idx) => {
            item.idx = idx + 1
          })
        }
      }
      this.staffSel = ''
    },
    insertPersonUni() {
      var CheckDupe = false
      this.personalMedData.map(value => {
        if (this.IdPersonal == value.STAFF_ID) {
          if (this.JoinMeet.filter(item => item.uid == value.STAFF_ID).length > 0) {
            CheckDupe = true
          }
          if (!CheckDupe) {
            this.JoinMeet.unshift({
              ...value,
              uid: value.STAFF_ID,
              full_Name: value.STAFF_NAME_THAI + ' ' + value.STAFF_SNAME_THAI,
              name: value.STAFF_NAME_THAI,
              sname: value.STAFF_SNAME_THAI,
              idCard: value.STAFF_PERS_ID,
              affiliation: value.FAC_NAME_THAI,
              position: '',
              phone: '',
              registerType_id: 2,
              status_reg: '0',
              files: [],
              type_details: 'บุคลากรคณะอื่น'
            })
            this.JoinMeet.map((item, idx) => {
              item.idx = idx + 1
            })
            this.IdPersonal = ''
          } else {
            this.$swal.fire({
              icon: 'error',
              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
            })
          }
        }
      })
    },
    insertStd(msg) {
      var CheckDupe = false
      if (msg == 'med') {
        this.studentData.map(value => {
          if (this.Idstudent == value.STUDENT_ID) {
            if (this.JoinMeet.filter(item => item.uid == value.STUDENT_ID).length > 0) {
              CheckDupe = true
            }
            if (!CheckDupe) {
              this.JoinMeet.unshift({
                ...value,
                uid: value.STUDENT_ID,
                full_Name: value.STUD_NAME_THAI + ' ' + value.STUD_SNAME_THAI,
                name: value.STUD_NAME_THAI,
                sname: value.STUD_SNAME_THAI,
                idCard: value.CITIZEN_ID,
                affiliation: 'คณะแพทยศาสตร์',
                position: '',
                phone: '',
                registerType_id: 1,
                status_reg: '0',
                files: [],
                type_details: 'นักศึกษาคณะแพทย์'
              })
              this.Idstudent = ''
              this.JoinMeet.map((item, idx) => {
                item.idx = idx + 1
              })
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
              })
            }
          }
        })
      } else {
        this.studentUniData.map(value => {
          if (this.IdstudentUni == value.STUDENT_ID) {
            if (this.JoinMeet.filter(item => item.uid == value.STUDENT_ID).length > 0) {
              CheckDupe = true
            }
            if (!CheckDupe) {
              this.JoinMeet.unshift({
                ...value,
                uid: value.STUDENT_ID,
                full_Name: value.STUD_NAME_THAI + ' ' + value.STUD_SNAME_THAI,
                name: value.STUD_NAME_THAI,
                sname: value.STUD_SNAME_THAI,
                idCard: value.CITIZEN_ID,
                affiliation: value.FAC_NAME_THAI,
                position: '',
                phone: '',
                registerType_id: 3,
                status_reg: '0',
                files: [],
                type_details: 'นักศึกษาคณะอื่น'
              })
              this.IdstudentUni = ''
              this.JoinMeet.map((item, idx) => {
                item.idx = idx + 1
              })
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
              })
            }

          }
        })
      }
    },
    checkKeyEnter(event) {
      if (event.key == "Enter") {
        if (this.JoinMeet.length > 0) {
          if (this.JoinMeet.filter(item => item.perid == this.staffSel).length > 0) {
            this.staffSel = ''
            this.$swal.fire({
              icon: 'error',
              title: 'พบข้อผิดพลาด บุคลากรที่เลือกมีข้อมูลอยู่แล้ว!!'
            })
          } else {
            var Staff = this.staffData.filter(item => item.perid == this.staffSel)
            if (Staff.length > 0) {
              this.JoinMeet.unshift({
                ...Staff[0],
                uid: Staff[0].perid,
                name: Staff[0].name,
                sname: Staff[0].surname,
                idCard: Staff[0].citizen_id,
                affiliation: Staff[0].dep_name,
                position: Staff[0].pos_name,
                phone: '',
                registerType_id: 0,
                status_reg: '0',
                type_details: 'บุคลากรคณะแพทย์'
              })
              this.JoinMeet.map((item, idx) => {
                item.idx = idx + 1
              })
            }
          }
        } else {
          Staff = this.staffData.filter(item => item.perid == this.staffSel)
          if (Staff.length > 0) {
            this.JoinMeet.unshift({
              ...Staff[0],
              uid: Staff[0].perid,
              name: Staff[0].name,
              sname: Staff[0].surname,
              idCard: Staff[0].citizen_id,
              affiliation: Staff[0].dep_name,
              position: Staff[0].pos_name,
              phone: '',
              registerType_id: 0,
              status_reg: '0',
              type_details: 'บุคลากรคณะแพทย์'
            })
            this.JoinMeet.map((item, idx) => {
              item.idx = idx + 1
            })
          }
        }
        this.staffSel = ''
      }
    },
    GenerateUrl() {
      return new Promise(resolve => {
        TinyURL.shorten(ConstData.PreGenerateLink + this.LinkGen).then(function (res) {
          resolve(res)
        }, function (err) {
          console.log(err)
        })
      })
    },
    ChooseCordiCount() {
      if (this.Cordi_Count == '0') {
        this.Count = '0'
      }
    },
    Copy() {
      this.$swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'คัดลอกลิงค์',
        showConfirmButton: false,
        timer: 1000
      })
      // var copyText = this.url
      //
      // /* Select the text field */
      // copyText.select();
      // copyText.setSelectionRange(0, 99999); /* For mobile devices */
      //
      // /* Copy the text inside the text field */
      // document.execCommand("copy");
    },
    getRandomFileName() {
      var timestamp = new Date().toISOString().replace(/[-:.]/g, "");
      var random = ("" + Math.random()).substring(2, 8);
      var random_number = timestamp + random;
      return random_number;
    },
    InsertMeetingData() {
      this.CheckPermission().then(res => {
        if (res) {
          this.$swal.fire({
            title: 'ยืนยันการทำรายการ',
            text: "กรุณาตรวจสอบข้อมูลให้ถูกต้อง ก่อนทำการบันทึกข้อมูล",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'ตกลง',
            cancelButtonText: 'ยกเลิก'
          }).then((result) => {
            if (result.value) {
              var Ref_id = ''
              if (this.Topic == '' || this.Date_start == '' || this.Date_end == ''
                  || this.Time_start == '' || this.Time_end == '' || this.dep_id == '' || this.Place == ''
                  || this.uuid == '' || this.url == '') {
                this.$swal.fire({
                  icon: 'error',
                  title: 'โปรดกรอกข้อมูล ช่องสีแดงให้ครบถ้วน !!'
                })
              } else if (this.Date_start > this.Date_end) {
                this.$swal.fire({
                  icon: 'error',
                  title: 'โปรดกรอกข้อมูลวันที่จัดงานให้ถูกต้อง'
                })
              } else if (this.Register_Cordi == '1') {
                if (this.Date_reg_start == '0000-00-00' || this.Date_reg_end == '0000-00-00') {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'โปรดกรอกข้อมูลวันที่เปิดรับลงทะเบียน'
                  })
                } else if (this.Date_reg_start > this.Date_reg_end) {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'โปรดกรอกข้อมูลวันที่เปิดรับลงทะเบียนให้ถูกต้อง'
                  })
                } else {
                  Ref_id = this.getRandomFileName()
                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting/', {
                    Topic: this.Topic,
                    Count_cordi: this.Cordi_Count,
                    Count: this.Count,
                    Date_start: this.Date_start,
                    Date_end: this.Date_end,
                    Date_reg_start: this.Date_reg_start,
                    Date_reg_end: this.Date_reg_end,
                    Time_start: this.Time_start,
                    Time_end: this.Time_end,
                    Rm: this.Rm,
                    Reg_status: this.Register_Cordi,
                    Limit_Reg_status: this.Register_Cordi2,
                    Ref_id: Ref_id,
                    dep_id: this.DepSelect,
                    Place: this.Place,
                    Cordi: this.ChkCordiMeeting,
                    uuid: this.LinkGen,
                    url: this.url,
                    create_by: this.MeData[0].perid,
                    create_time: 'now()',
                  }, this.headerAxiosPUT).then(res => {
                    if (res.data.status) {
                      if (this.JoinMeet.length > 0) {
                        var countInsert = 0
                        this.JoinMeet.map(Join_i => {
                          /*axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join/', {
                            perid: Join_i.perid,
                            D_meeting_uuid: this.LinkGen,
                            create_by: this.MeData[0].perid,
                            create_time: 'now()',
                          }, this.headerAxiosPUT).then(resJoinMeet => {*/
                          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2/', {
                            D_meeting_uuid: this.LinkGen,
                            uid: Join_i.uid,
                            name: Join_i.name,
                            sname: Join_i.sname,
                            id_card: Join_i.idCard,
                            affiliation: Join_i.affiliation,
                            position: Join_i.position,
                            phone: Join_i.phone,
                            registerType_id: Join_i.registerType_id,
                            Create_By: this.MeData[0].perid,
                            Create_Time: 'now()',
                          }, this.headerAxiosPUT).then(resJoinMeet => {
                            if (resJoinMeet.status) {
                              countInsert++
                              if (countInsert == this.JoinMeet.length) {
                                if (this.FileMeeting.length > 0) {
                                  var countFileMeeting = 0
                                  this.FileMeeting.map((item) => {
                                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files', {
                                      File_name: item.name,
                                      File_path: item.path,
                                      File_type: item.type,
                                      Ref_id: Ref_id,
                                      Create_By: this.MeData[0].perid,
                                      Create_Time: 'now()',
                                    }, this.headerAxiosPUT).then(res => {
                                      if (res.data.status) {
                                        countFileMeeting++
                                        if (countFileMeeting == this.FileMeeting.length) {
                                          this.Topic = ''
                                          this.Cordi_Count = '0'
                                          this.Count = '0'
                                          this.Date_start = ''
                                          this.Date_end = ''
                                          this.Date_reg_start = ''
                                          this.Date_reg_end = ''
                                          this.Time_start = ''
                                          this.Time_end = ''
                                          this.DepSelect = ''
                                          this.Place = ''
                                          this.LinkGen = ''
                                          this.url = ''
                                          this.Place = ''
                                          this.Rm = ''
                                          this.Register_Cordi = '0'
                                          this.Register_Cordi2 = '0'
                                          this.JoinMeet = []
                                          this.files = []
                                          this.FileMeeting = []
                                          this.txtAlert = []
                                          this.alert = false
                                          this.tab = 'DataMeeting'
                                          this.staffSel = ''
                                          this.init()
                                          this.$swal.fire({
                                            icon: 'success',
                                            title: 'เพิ่มข้อมูลการประชุมสำเร็จ!!'
                                          })
                                        }
                                      }
                                    })
                                  })
                                } else {
                                  this.Topic = ''
                                  this.Cordi_Count = '0'
                                  this.Count = '0'
                                  this.Date_start = ''
                                  this.Date_end = ''
                                  this.Date_reg_start = ''
                                  this.Date_reg_end = ''
                                  this.Time_start = ''
                                  this.Time_end = ''
                                  this.DepSelect = ''
                                  this.Place = ''
                                  this.LinkGen = ''
                                  this.url = ''
                                  this.Place = ''
                                  this.Rm = ''
                                  this.Register_Cordi = '0'
                                  this.Register_Cordi2 = '0'
                                  this.JoinMeet = []
                                  this.files = []
                                  this.FileMeeting = []
                                  this.txtAlert = []
                                  this.alert = false
                                  this.tab = 'DataMeeting'
                                  this.staffSel = ''
                                  this.init()
                                  this.$swal.fire({
                                    icon: 'success',
                                    title: 'เพิ่มข้อมูลการประชุมสำเร็จ!!'
                                  })
                                }
                              }
                            }
                          })
                        })
                      } else {
                        if (this.FileMeeting.length > 0) {
                          var countFileMeeting = 0
                          this.FileMeeting.map((item) => {
                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files', {
                              File_name: item.name,
                              File_path: item.path,
                              File_type: item.type,
                              Ref_id: Ref_id,
                              Create_By: this.MeData[0].perid,
                              Create_Time: 'now()',
                            }, this.headerAxiosPUT).then(res => {
                              if (res.data.status) {
                                countFileMeeting++
                                if (countFileMeeting == this.FileMeeting.length) {
                                  this.Topic = ''
                                  this.Cordi_Count = '0'
                                  this.Count = '0'
                                  this.Date_start = ''
                                  this.Date_end = ''
                                  this.Date_reg_start = ''
                                  this.Date_reg_end = ''
                                  this.Time_start = ''
                                  this.Time_end = ''
                                  this.DepSelect = ''
                                  this.Place = ''
                                  this.LinkGen = ''
                                  this.url = ''
                                  this.Place = ''
                                  this.Rm = ''
                                  this.Register_Cordi = '0'
                                  this.Register_Cordi2 = '0'
                                  this.JoinMeet = []
                                  this.files = []
                                  this.FileMeeting = []
                                  this.txtAlert = []
                                  this.alert = false
                                  this.tab = 'DataMeeting'
                                  this.staffSel = ''
                                  this.init()
                                  this.$swal.fire({
                                    icon: 'success',
                                    title: 'เพิ่มข้อมูลการประชุมสำเร็จ!!'
                                  })
                                }
                              }
                            })
                          })
                        } else {
                          this.Topic = ''
                          this.Cordi_Count = '0'
                          this.Count = '0'
                          this.Date_start = ''
                          this.Date_end = ''
                          this.Date_reg_start = ''
                          this.Date_reg_end = ''
                          this.Time_start = ''
                          this.Time_end = ''
                          this.DepSelect = ''
                          this.Place = ''
                          this.LinkGen = ''
                          this.url = ''
                          this.Place = ''
                          this.Rm = ''
                          this.Register_Cordi = '0'
                          this.Register_Cordi2 = '0'
                          this.JoinMeet = []
                          this.files = []
                          this.FileMeeting = []
                          this.txtAlert = []
                          this.alert = false
                          this.tab = 'DataMeeting'
                          this.staffSel = ''
                          this.init()
                          this.$swal.fire({
                            icon: 'success',
                            title: 'เพิ่มข้อมูลการประชุมสำเร็จ!!'
                          })
                        }
                      }
                      if (this.ChkCordiMeeting == '1') {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_target/', {
                          Ref_id: Ref_id,
                          type: this.TypeGroup,
                          create_by: this.MeData[0].perid,
                          create_time: 'now()',
                        }, this.headerAxiosPUT).then(resTarget => {
                          if (resTarget.data) {
                            if (this.TypeGroup == '0') {
                              if (this.DataCondi.length > 0) {
                                var countDataCondi = 0
                                this.DataCondi.map((item) => {
                                  const DataObj = {
                                    PosCode: item.PosCode,
                                    Level: item.Level,
                                    WSYear: item.workAgeStart,
                                    WEYear: item.workAgeEnd,
                                    D_meeting_target_Ref_id: Ref_id,
                                  }
                                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_person_level', DataObj, this.headerAxiosPUT).then(res => {
                                    if (res.data.status) {
                                      countDataCondi++
                                      if (countDataCondi == this.DataCondi.length) {
                                        this.DataCondi = []
                                        this.TypeGroup = '0'
                                        this.ChkCordiMeeting == '0'
                                      }
                                    }
                                  })
                                })
                              }
                              if (this.DepQuotaData.length > 0) {
                                var countDepQuota = 0
                                this.DepQuotaData.map((item_dep_q) => {
                                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/quata_dep_reg', {
                                    D_meeting_target_Ref_id: Ref_id,
                                    dep_type: item_dep_q.type_id,
                                    dep_id: item_dep_q.dep_id,
                                    dep_group_id: item_dep_q.dep_group_id,
                                    count: item_dep_q.count,
                                    create_by: this.MeData[0].perid,
                                    create_time: 'now()',
                                  }, this.headerAxiosPUT).then(res => {
                                    if (res.data.status) {
                                      countDepQuota++
                                      if (countDepQuota == this.DepQuotaData.length) {
                                        this.DepQuotaData = []
                                        this.TypeGroup = '0'
                                        this.ChkCordiMeeting == '0'
                                      }
                                    }
                                  })
                                })
                              }
                            } else {
                              this.ChkCordiMeeting == '0'
                              this.TypeGroup = '0'
                              this.DepQuotaData = []
                              this.DataCondi = []
                            }
                          } else {
                            this.ChkCordiMeeting == '0'
                            this.TypeGroup = '0'
                            this.DepQuotaData = []
                            this.DataCondi = []
                          }
                        })
                      }
                    }
                  })
                }
              } else {
                if (this.Cordi_Count == '1' && parseInt(this.Count) == 0) {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'โปรดระบุจำนวนผู้เข้าร่วมประชุม ให้ถูกต้อง'
                  })
                } else {
                  Ref_id = this.getRandomFileName()
                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting/', {
                    Topic: this.Topic,
                    Count_cordi: this.Cordi_Count,
                    Count: this.Count,
                    Date_start: this.Date_start,
                    Date_end: this.Date_end,
                    Date_reg_start: this.Date_reg_start,
                    Date_reg_end: this.Date_reg_end,
                    Time_start: this.Time_start,
                    Time_end: this.Time_end,
                    Rm: this.Rm,
                    Reg_status: this.Register_Cordi,
                    Limit_Reg_status: this.Register_Cordi2,
                    Ref_id: Ref_id,
                    dep_id: this.DepSelect,
                    Place: this.Place,
                    Cordi: this.ChkCordiMeeting,
                    uuid: this.LinkGen,
                    url: this.url,
                    create_by: this.MeData[0].perid,
                    create_time: 'now()',
                  }, this.headerAxiosPUT).then(res => {
                    if (res.data.status) {
                      if (this.JoinMeet.length > 0) {
                        var countInsert = 0
                        this.JoinMeet.map(Join_i => {
                          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2/', {
                            D_meeting_uuid: this.LinkGen,
                            uid: Join_i.uid,
                            name: Join_i.name,
                            sname: Join_i.sname,
                            id_card: Join_i.idCard,
                            affiliation: Join_i.affiliation,
                            position: Join_i.position,
                            phone: Join_i.phone,
                            registerType_id: Join_i.registerType_id,
                            Create_By: this.MeData[0].perid,
                            Create_Time: 'now()',
                          }, this.headerAxiosPUT).then(resJoinMeet => {
                            if (resJoinMeet.status) {
                              countInsert++
                              if (countInsert == this.JoinMeet.length) {
                                if (this.FileMeeting.length > 0) {
                                  var countFileMeeting = 0
                                  this.FileMeeting.map((item) => {
                                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files', {
                                      File_name: item.name,
                                      File_path: item.path,
                                      File_type: item.type,
                                      Ref_id: Ref_id,
                                      Create_By: this.MeData[0].perid,
                                      Create_Time: 'now()',
                                    }, this.headerAxiosPUT).then(res => {
                                      if (res.data.status) {
                                        countFileMeeting++
                                        if (countFileMeeting == this.FileMeeting.length) {
                                          this.Topic = ''
                                          this.Cordi_Count = '0'
                                          this.Count = '0'
                                          this.Date_start = ''
                                          this.Date_end = ''
                                          this.Date_reg_start = ''
                                          this.Date_reg_end = ''
                                          this.Time_start = ''
                                          this.Time_end = ''
                                          this.DepSelect = ''
                                          this.Place = ''
                                          this.LinkGen = ''
                                          this.url = ''
                                          this.Place = ''
                                          this.Rm = ''
                                          this.Register_Cordi = '0'
                                          this.Register_Cordi2 = '0'
                                          this.JoinMeet = []
                                          this.files = []
                                          this.FileMeeting = []
                                          this.txtAlert = []
                                          this.alert = false
                                          this.tab = 'DataMeeting'
                                          this.staffSel = ''
                                          this.init()
                                          this.$swal.fire({
                                            icon: 'success',
                                            title: 'เพิ่มข้อมูลการประชุมสำเร็จ!!'
                                          })
                                        }
                                      }
                                    })
                                  })
                                } else {
                                  this.Topic = ''
                                  this.Cordi_Count = '0'
                                  this.Count = '0'
                                  this.Date_start = ''
                                  this.Date_end = ''
                                  this.Date_reg_start = ''
                                  this.Date_reg_end = ''
                                  this.Time_start = ''
                                  this.Time_end = ''
                                  this.DepSelect = ''
                                  this.Place = ''
                                  this.LinkGen = ''
                                  this.url = ''
                                  this.Place = ''
                                  this.Rm = ''
                                  this.Register_Cordi = '0'
                                  this.Register_Cordi2 = '0'
                                  this.JoinMeet = []
                                  this.files = []
                                  this.FileMeeting = []
                                  this.txtAlert = []
                                  this.alert = false
                                  this.tab = 'DataMeeting'
                                  this.staffSel = ''
                                  this.init()
                                  this.$swal.fire({
                                    icon: 'success',
                                    title: 'เพิ่มข้อมูลการประชุมสำเร็จ!!'
                                  })
                                }
                              }
                            }
                          })
                        })
                      } else {
                        if (this.FileMeeting.length > 0) {
                          var countFileMeeting = 0
                          this.FileMeeting.map((item) => {
                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files', {
                              File_name: item.name,
                              File_path: item.path,
                              File_type: item.type,
                              Ref_id: Ref_id,
                              Create_By: this.MeData[0].perid,
                              Create_Time: 'now()',
                            }, this.headerAxiosPUT).then(res => {
                              if (res.data.status) {
                                countFileMeeting++
                                if (countFileMeeting == this.FileMeeting.length) {
                                  this.Topic = ''
                                  this.Cordi_Count = '0'
                                  this.Count = '0'
                                  this.Date_start = ''
                                  this.Date_end = ''
                                  this.Date_reg_start = ''
                                  this.Date_reg_end = ''
                                  this.Time_start = ''
                                  this.Time_end = ''
                                  this.DepSelect = ''
                                  this.Place = ''
                                  this.LinkGen = ''
                                  this.url = ''
                                  this.Place = ''
                                  this.Rm = ''
                                  this.Register_Cordi = '0'
                                  this.Register_Cordi2 = '0'
                                  this.JoinMeet = []
                                  this.files = []
                                  this.FileMeeting = []
                                  this.txtAlert = []
                                  this.alert = false
                                  this.tab = 'DataMeeting'
                                  this.staffSel = ''
                                  this.init()
                                  this.$swal.fire({
                                    icon: 'success',
                                    title: 'เพิ่มข้อมูลการประชุมสำเร็จ!!'
                                  })
                                }
                              }
                            })
                          })
                        } else {
                          this.Topic = ''
                          this.Cordi_Count = '0'
                          this.Count = '0'
                          this.Date_start = ''
                          this.Date_end = ''
                          this.Date_reg_start = ''
                          this.Date_reg_end = ''
                          this.Time_start = ''
                          this.Time_end = ''
                          this.DepSelect = ''
                          this.Place = ''
                          this.LinkGen = ''
                          this.url = ''
                          this.Place = ''
                          this.Rm = ''
                          this.Register_Cordi = '0'
                          this.Register_Cordi2 = '0'
                          this.JoinMeet = []
                          this.files = []
                          this.FileMeeting = []
                          this.txtAlert = []
                          this.alert = false
                          this.tab = 'DataMeeting'
                          this.staffSel = ''
                          this.init()
                          this.$swal.fire({
                            icon: 'success',
                            title: 'เพิ่มข้อมูลการประชุมสำเร็จ!!'
                          })
                        }
                      }

                      if (this.ChkCordiMeeting == '1') {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_target/', {
                          Ref_id: Ref_id,
                          type: this.TypeGroup,
                          create_by: this.MeData[0].perid,
                          create_time: 'now()',
                        }, this.headerAxiosPUT).then(resTarget => {
                          if (resTarget.data) {
                            if (this.TypeGroup == '0') {
                              if (this.DepQuotaData.length > 0) {
                                var countDepQuota = 0
                                this.DepQuotaData.map((item_dep_q) => {
                                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/quata_dep_reg', {
                                    D_meeting_target_Ref_id: Ref_id,
                                    dep_type: item_dep_q.type_id,
                                    dep_id: item_dep_q.dep_id,
                                    dep_group_id: item_dep_q.dep_group_id,
                                    count: item_dep_q.count,
                                    create_by: this.MeData[0].perid,
                                    create_time: 'now()',
                                  }, this.headerAxiosPUT).then(res => {
                                    if (res.data.status) {
                                      countDepQuota++
                                      if (countDepQuota == this.DepQuotaData.length) {
                                        this.DepQuotaData = []
                                      }
                                    }
                                  })
                                })
                              }
                            }
                          }
                        })
                      }
                    }
                  })
                }
              }
            }
          })
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
          })
        }
      })
    },
    FileImport() {
      this.sheets = []
      this.ChooseSheet = ''
      this.Exec = false
      readXlsxFile(this.filesImportEmp[0], {getSheets: true}).then((sheets) => {
        this.sheets = sheets
      })
    },
    downloadTemplateEmp() {
      var link = document.createElement("a");
      // If you don't know the name or want to use
      // the webserver default set name = ''
      link.setAttribute('download', 'Template ตัวอย่าง การนำเข้าข้อมูลบุคลากรผู้เข้าร่วม');
      link.href = 'https://medhr.medicine.psu.ac.th/HrTrain2/' + (this.typeImport == '1' ? 'TemplateEmp.xlsx' : this.typeImport == '2' ? 'TemplateStudent.xlsx' : 'TemplateEmpOther.xlsx')
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    closeDi_ImportDataEmp() {
      this.ShowAlertErrImp = false
      this.MessageErrorImp = ''
      this.empData = []
      this.sheets = []
      this.ChooseSheet = ''
      this.Exec = false
      this.filesImportEmp = []
      this.DialogExamImportEmp = false
      this.DialogImportEmp = false
    },
    importExcelData(type) {
      this.typeImport = type
      this.DialogImportEmp = true
    },
    Del_item_ImportEmp(idx) {
      this.empData.map((item, index) => {
        if (item.idEmp == idx) {
          this.empData.splice(index, 1)
        }
      })
    },
    ChooseSheetAction() {
      this.empHeaders = []
      this.empData = []
      this.Exec = false
      this.ShowAlertErrImp = false
      this.MessageErrorImp = ''
      var CheckDupe = false
      var empDataDump = []
      var textID = ''
      readXlsxFile(this.filesImportEmp[0], {sheet: this.ChooseSheet}).then((row) => {
        row.map((items, index) => {
          var obj = {};
          items.map((data, idx) => {
            if (index == 0) {
              this.empHeaders.push({
                text: data,
                value: 'keys' + idx,
              })
            } else {
              obj['keys' + idx] = data;
              textID += "'" + data + "',"
              if (idx == items.length - 1) {
                empDataDump.push(obj)
              }
            }
          })
        })
        if (textID != '') {
          textID = textID.slice(0, -1);
        }
        if (this.typeImport == '1') {
          if (empDataDump.length > 0) {
            empDataDump.map(itemEmp => {
              CheckDupe = false
              this.staffData.map(async (staff_I) => {
                if (staff_I.perid == itemEmp.keys0) {
                  if (this.JoinMeet.filter(item => item.uid == staff_I.perid).length > 0) {
                    CheckDupe = true
                  }
                  if (!CheckDupe) {
                    this.empData.push({
                      idEmp: this.empData.length,
                      ...staff_I,
                      uid: staff_I.perid,
                      name: staff_I.name,
                      sname: staff_I.surname,
                      idCard: staff_I.citizen_id,
                      affiliation: staff_I.dep_name,
                      position: '',
                      phone: '',
                      registerType_id: 0,
                      status_reg: '0',
                      type_details: 'บุคลากรคณะแพทย์'
                    })
                  } else {
                    this.MessageErrorImp += '<p style="font-weight: bold;color: red"">' + staff_I.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                    this.ShowAlertErrImp = true
                  }
                }
              })
            })
          }
        } else if (this.typeImport == '2') {
          axios.post(ConstData.ConnectionHost + '/HrTrain2/serviceAPI.php', {
            queryName: 'getStdMedPSU',
            param: btoa(encodeURIComponent(JSON.stringify({
              queryId: textID,
            })))
          }).then(res => {
            if (res.data.length > 0) {
              if (empDataDump.length > 0) {
                empDataDump.map(itemEmp => {
                  CheckDupe = false
                  res.data.map(async (stdI) => {
                    if (stdI.STUDENT_ID == itemEmp.keys0) {
                      if (this.JoinMeet.filter(item => item.uid == stdI.STUDENT_ID).length > 0) {
                        CheckDupe = true
                      }
                      if (!CheckDupe) {
                        this.empData.push({
                          idEmp: this.empData.length,
                          ...stdI,
                          uid: stdI.STUDENT_ID,
                          full_Name: stdI.STUD_NAME_THAI + ' ' + stdI.STUD_SNAME_THAI,
                          name: stdI.STUD_NAME_THAI,
                          sname: stdI.STUD_SNAME_THAI,
                          idCard: stdI.CITIZEN_ID,
                          affiliation: 'นักศึกษาคณะแพทย์',
                          position: '',
                          phone: '',
                          registerType_id: 1,
                          status_reg: '0',
                          type_details: 'นักศึกษาคณะแพทย์'
                        })
                      } else {
                        this.MessageErrorImp += '<p style="font-weight: bold;color: red"">' + stdI.STUD_NAME_THAI + ' ' + stdI.STUD_SNAME_THAI + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                        this.ShowAlertErrImp = true
                      }
                    }
                  })
                })
              }
            }
          })
        } else {
          if (empDataDump.length > 0) {
            var count = 0
            empDataDump.map(itemEmp => {
              CheckDupe = false
              if (itemEmp.keys0 != null) {
                if (this.JoinMeet.filter(item => item.name == itemEmp.keys0 && item.sname == itemEmp.keys1).length > 0) {
                  CheckDupe = true
                }
                if (!CheckDupe) {
                  if (this.JoinMeet.length > 0) {
                    while (this.JoinMeet.filter(item => item.uid == 'P_' + count).length > 0 || this.empData.filter(item => item.uid == 'P_' + count).length > 0) {
                      count++
                    }
                  } else if(this.empData.length > 0) {
                    while (this.empData.filter(item => item.uid == 'P_' + count).length > 0) {
                      count++
                    }
                  }
                  this.empData.push({
                    idEmp: this.empData.length,
                    uid: 'P_' + count,
                    full_Name: itemEmp.keys0 + ' ' + itemEmp.keys1,
                    name: itemEmp.keys0,
                    sname: itemEmp.keys1,
                    idCard: '',
                    affiliation: itemEmp.keys2,
                    position: itemEmp.keys3,
                    phone: '',
                    registerType_id: 4,
                    status_reg: '0',
                    type_details: 'บุคคลภายนอก'
                  })
                } else {
                  this.MessageErrorImp += '<p style="font-weight: bold;color: red"">' + itemEmp.keys0 + ' ' + itemEmp.keys1 + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                  this.ShowAlertErrImp = true
                }
              }
            })
          }
        }

        if (this.MessageErrorImp != '') {
          this.ShowAlertErrImp = true
        }
        this.DialogExamImportEmp = true
      })
    },
    ImportDataToDb() {
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: "คุณต้องการนำเข้าข้อมูลบุคลากรใช่หรือไม่ ?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          this.dialogLoading = true
          if (this.empData.length > 0) {
            this.empData.map(async (staff_I, idx) => {
              this.JoinMeet.unshift({
                ...staff_I
              })
              this.JoinMeet.map((item, idx) => {
                item.idx = idx + 1
              })
              if (idx == this.empData.length - 1) {
                this.dialogLoading = false
                this.closeDi_ImportDataEmp()
                this.$swal.fire({
                  timer: 1500,
                  showConfirmButton: false,
                  icon: 'success',
                  title: 'บันทึกข้อมูลผู้เข้าร่วม จากไฟล์นำเข้า สำเร็จ!!'
                })
              }
            })
          } else {
            this.dialogLoading = false
            this.$swal.fire({
              icon: 'error',
              title: 'ไม่สามารถนำเข้าข้อมูลบุคลากรได้ เนื่องจากไม่พบข้อมูลรายชื่อบุคลากรที่ต้องการจะนำเข้า'
            })
          }
        }
      })
    },
  },
  mounted() {
    this.initMeData().then(res => {
      if (res) {
        this.getPermissionData({
          perid: this.MeData[0].perid
        }).then(resAdmin => {
          if (resAdmin) {
            this.PermissionAdmin.map((Per_i, idx) => {
              if (Per_i.permission_id == '11000') {
                this.CheckAdmin = true
                this.initDepartData()
                this.initStaffData().then(res => {
                  if (res) {
                    if (this.staffData.length > 0) {
                      this.staffData.map(item => {
                        item.customDetail = item.full_Name + ' รหัส (' + item.perid + ')' + ' ' + item.dep_name + ' (' + item.dep_group_name + ')'
                      })
                    }
                  }
                })
                this.init()
              } else {
                if (!this.CheckAdmin && idx == this.PermissionAdmin.length - 1) {
                  this.$router.push('/')
                }
              }
            })
          } else {
            this.getPermissionUserData({
              perid: this.MeData[0].perid
            }).then(resUser => {
              if (resUser) {
                this.Permission.map((Per_i, idx) => {
                  if (Per_i.permission_id == '11000') {
                    this.CheckSubAdmin = true
                    this.initDepartData()
                    this.initStaffData().then(res => {
                      if (res) {
                        if (this.staffData.length > 0) {
                          this.staffData.map(item => {
                            item.customDetail = item.full_Name + ' รหัส (' + item.perid + ')' + ' ' + item.dep_name + ' (' + item.dep_group_name + ')'
                          })
                        }
                      }
                    })
                    this.init()
                  } else {
                    if (!this.CheckSubAdmin && idx == this.Permission.length - 1) {
                      this.$router.push('/')
                    }
                  }
                })
              } else {
                this.CheckSubAdmin = false
                this.CheckAdmin = false
                this.$router.push('/')
              }
            })
          }
        })
      }
    }).catch(reason => {
      console.log('Reject = ' + reason)
    })
  }
}
</script>

<style scoped>
.v-label {
  color: black;
}

.v-card {
  border: 1px solid;
}

.v-text-field >>> input {
  color: black;
}

.v-text-field >>> label {
  color: black;
  font-weight: bold;
}

.v-text-field >>> button {
  font-size: 0.1em;
}
</style>
